module.exports = __webpack_public_path__ + "img/vilella.5711c8fa.png";